import { authHeader } from "./auth-header";
import api from "../../common/api";

const getCareer = (params) => {
  return api.get(process.env.REACT_APP_API_URL + "careers", {
    headers: authHeader(),
    withCredentials: true,
    params,
  });
};

export default {
  getCareer,
};
